import React from "react";
import {
    Box,
    FormControl,
    styled,
    TextField,
    Autocomplete
} from "@mui/material";
import STStandTypeComponent from "../../../api/StationaryTesting/STStandType";
import STStandTypeForm from "./STStandTypeForm";
import { getMessage } from "../../../global";
import { useAuth } from "../../../context/AuthContext";
import { Roles } from "../../../constants/roles";
import ModalSimpleButton from '../../../components/Modal/ModalSimpleButton';
import { GlobalButton, GlobalSecondaryButton } from "../../styles";

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    marginBottom: "20px"
}));

const StyledFormControl = styled(FormControl)(() => ({
    display: 'flex',
    width: "50rem"
}));

const StyledDiv = styled('div')({
    display: 'flex',
    justifyContent: "space-between"
});

const STStandType = (props) => {

    const initialStateStandType = {
        id: undefined,
        standTypeName: "",
        isActive: false,
    };

    const validationsInitialState =
    {
        standTypeName: "",
    };

    const [isAdd, setIsAdd] = React.useState(false);
    const [infoData, setInfoData] = React.useState(initialStateStandType);
    const [standTypeList, setStandTypeList] = React.useState(null);
    const [invalidField, setInvalidField] = React.useState(validationsInitialState);

    const [modalSimpleButton, setModalSimpleButton] = React.useState(false);
    const [modalSimpleButtonText, setModalSimpleButtonText] = React.useState('');
    const [modalSimpleTitle, setModalSimpleTitle] = React.useState('');
    const [modalSimpleText, setModalSimpleText] = React.useState('');

    const { hasAnyRole } = useAuth();
    const canEdit = hasAnyRole([Roles.StationaryTestingSME, Roles.Developer]);

    function closeModalSimpleButton() {
        setModalSimpleButton(false);
    }

    function openModalSimpleButton(title, text, buttonText) {
        setModalSimpleButtonText(buttonText)
        setModalSimpleButton(true);
        setModalSimpleTitle(title);
        setModalSimpleText(text);
    }

    function handleSubmit(event) {
        event.preventDefault();

        if (!validateFields()) {
            if (infoData.id !== undefined)
                saveStandType();
            else {

                STStandTypeComponent.get(infoData.standTypeName).then((standTypeExists) => {
                    if ((standTypeExists !== undefined && standTypeExists !== null))
                        openModalSimpleButton('Fail', 'This stand type name already exist', 'Ok');
                    else saveStandType();
                });
            }
        }
    }

    function saveStandType() {

        let standType = new STStandTypeComponent({
            standTypeName: infoData.standTypeName,
            isActive: infoData.isActive
        });

        if (infoData.id === undefined) {
            STStandTypeComponent.add(standType).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Stand Type saved with success', 'Ok');
                    loadStandTypeFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        } else {
            STStandTypeComponent.update(standType).then((res) => {
                if (res) {
                    resetForm();
                    openModalSimpleButton('Success', 'Stand Type updated with success', 'Ok');
                    loadStandTypeFilter();
                }
                else
                    openModalSimpleButton('Fail', 'Something went wrong, please try after sometime', 'Ok');
            });
        }
    }

    function handleChangeIsAdd() {
        setIsAdd(true);
        resetForm();
    }


    function loadStandTypeFilter() {
        STStandTypeComponent.getAll().then((res) => {
            if (res.length > 0) {

                let array = [];
                array.push({ id: undefined, standTypeName: "" });
                array.push(...res);

                setStandTypeList(array);
            }
        });
    }

    function validateFields() {
        let requiredStandTypeName = infoData.standTypeName === "" ? getMessage('REQUIRED_FIELD') : "";

        setInvalidField({
            ...invalidField,
            standTypeName: requiredStandTypeName
        });

        return ((requiredStandTypeName !== ""));
    }

    function resetForm() {

        setInfoData(initialStateStandType);
        setInvalidField(validationsInitialState);
    }

    function handleChangeSTStandTypeFilter(idSelected) {
        setInfoData(initialStateStandType);

        setInfoData(() => ({
            ...initialStateStandType,
            id: idSelected,
            standTypeName: idSelected
        }));

        setIsAdd(true);

        setInvalidField(validationsInitialState);

        if (idSelected !== "") {
            STStandTypeComponent.get(idSelected).then((standType) => {
                if (standType !== null) {

                    setInfoData(() => ({
                        ...infoData,
                        id: idSelected,
                        standTypeName: standType.standTypeName,
                        isActive: standType.isActive,
                    }));
                }
            });
        }
    }

    React.useMemo(() => {
        if (standTypeList === null) {
            loadStandTypeFilter();
        }
    }, [standTypeList])

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <StyledDiv>
                    <div>
                        <StyledBox>
                            <StyledFormControl sx={{ m: 1, width: "35rem" }} variant='outlined'>

                                <StyledBox sx={{ justifyContent: "space-between" }}>
                                    <Autocomplete
                                        noOptionsText={"Loading Stand Type..."}
                                        value={infoData.standTypeName === '' ? null : infoData.standTypeName}
                                        onChange={(e, value) => {
                                            handleChangeSTStandTypeFilter(value);
                                        }}
                                        disablePortal
                                        options={standTypeList ? standTypeList.map((standType) => standType.standTypeName) : []}
                                        sx={{ width: "35rem" }}
                                        renderInput={(params) => <TextField {...params} variant="outlined" size="small" margin="none" label="Stand Type" />}
                                        autoSelect
                                    />

                                    <GlobalSecondaryButton sx={{ width: "8rem", marginLeft:"1rem" }}
                                        variant='contained'
                                        type="button"
                                        onClick={handleChangeIsAdd}
                                    >Add New</GlobalSecondaryButton>

                                </StyledBox>

                            </StyledFormControl>

                        </StyledBox>

                        {isAdd === true && <STStandTypeForm
                            infoData={infoData} setInfoData={setInfoData}
                            invalidField={invalidField}
                            handleChangeSTStandTypeFilter={handleChangeSTStandTypeFilter}
                            canEdit={canEdit}
                        >
                        </STStandTypeForm>}

                        {
                            isAdd === true &&
                            <div>
                                <StyledBox sx={{ mb: 1, mt: 2, justifyContent: "space-between" }}>
                                    <GlobalButton sx={{ width: "8rem" }}
                                        variant='contained'
                                        type="submit"
                                        disabled={!canEdit}>Save</GlobalButton>
                                </StyledBox>
                            </div>
                        }

                    </div>

                </StyledDiv>

            </form >

            <ModalSimpleButton title={modalSimpleTitle} buttonText={modalSimpleButtonText} buttonAction={closeModalSimpleButton} open={modalSimpleButton} setOpen={setModalSimpleButton}>
                <label>
                    {modalSimpleText}
                </label>
            </ModalSimpleButton>

        </div >
    )
}

export default STStandType;